import { useEffect } from 'react';

/**
 * Wires up the two scroll behaviours the site leans on:
 *
 *  - `.reveal` elements fade up once they are meaningfully in view.
 *  - `.narrative-point` gains `.active` while it owns the viewport, so the
 *    surrounding points can recede.
 *
 * Both use the same 0.6 threshold, which is what makes a point feel like it
 * "lands" rather than lighting up on the way past.
 */
export default function useScrollEffects() {
  useEffect(() => {
    const revealTargets = document.querySelectorAll('.reveal');
    const points = document.querySelectorAll('.narrative-point');

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('show');
        });
      },
      { threshold: 0.6 }
    );

    const activeObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          points.forEach((p) => p.classList.remove('active'));
          entry.target.classList.add('active');
        });
      },
      { threshold: 0.6 }
    );

    revealTargets.forEach((el) => revealObserver.observe(el));
    points.forEach((el) => activeObserver.observe(el));

    return () => {
      revealObserver.disconnect();
      activeObserver.disconnect();
    };
  }, []);
}
